module.exports = __webpack_public_path__ + "static/img/video1.b14a49ca.jpg";